<template>
  <div class="add-person">
    <Card>
      <h2 v-if="!personInfo.id" style="text-align: center;margin:20px 0 0 0;">新增个人通讯录</h2>
      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改个人通讯录</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="姓名" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写姓名"></Input>
          </FormItem>
          <FormItem label="职务" prop="job">
            <Input v-model="formValidate.job" placeholder="请填写职务"></Input>
          </FormItem>
          <FormItem label="手机" prop="phone">
            <Input v-model="formValidate.phone" placeholder="请填写手机"></Input>
          </FormItem>
          <FormItem label="办公室电话" prop="officePhone">
            <Input v-model="formValidate.officePhone" placeholder="请填写办公室电话"></Input>
          </FormItem>
          <FormItem label="所属科室" prop="belongDepartment">
            <Input v-model="formValidate.belongDepartment" placeholder="请填写所属科室"></Input>
          </FormItem>
          <FormItem label="单位" prop="unit">
            <TreeSelect v-model="formValidate.unit" placeholder="请选择单位" class="treeSelect" transfer clearable
                        :data="unitList"/>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <!--          <FormItem>-->
          <!--            <Button v-if="!personInfo.id" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="personInfo.id" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!personInfo.id" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">
            新增
          </Button>
          <Button v-if="personInfo.id" type="primary" :loading="saveLoading" @click="editTeam('formValidate')">编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="goBack" type="primary" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "addPersonPhone",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必填'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      saveLoading: false,
      eventList: [],
      unitList: [],
      personInfo: {},
      formValidate: {
        name: '',
        job: '',
        phone: '',
        officePhone: '',
        belongDepartment: '',
        unit: '',
        remark: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        job: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        officePhone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        belongDepartment: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        unit: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        remark: [
          { required: false, message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getAllEvents()
    this.getAllUnit()
    if (this.$route.params.row) {
      this.personInfo = this.$route.params.row.personalAddressBook
      this.formValidate = this.personInfo
    }
  },
  methods: {
    goBack(){
      // 跳转关闭当前页
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'personalList'
      })
    },
    //获取事件类型/api/event/getAll
    getAllEvents() {
      this.$http.get('/api/event/getAll').then(res => {
        console.log(res)
        this.eventList = res.data.data
        // this.eventList = this.eventList.Map(item => item.id = Number(item.id))
      })
    },
    getAllUnit() {
      this.$http.get('/api/unit/getUnitList').then(res => {
        // console.log(res)
        this.unitList = res.data.data
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.post('/api/pab/personalAddressBooks', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'personalList'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.put('/api/pab/personalAddressBooks', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'personalList'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.add-person {

}
</style>
